module.exports = __webpack_public_path__ + "static/SantiagoJimenez-4cfb6a4b1a420e06918b95070c9097af.jpg";